import { AnyAction } from 'redux';

const GET_SEARCH_HIERARCHY_DETAIL = 'GET_SEARCH_HIERARCHY_DETAIL';

const intialState = { data: [] };

export async function setSearchDetail(dispatch: any, searchDetail: any) {
  dispatch({
    type: GET_SEARCH_HIERARCHY_DETAIL,
    data: searchDetail
  });
}

export const searchDetailReducer = (state = intialState, action: AnyAction) => {
  switch (action.type) {
    case GET_SEARCH_HIERARCHY_DETAIL: {
      return {
        ...state,
        data: action.data
      };
    }
    default:
      return state;
  }
};
